<template>
    <img src="/images/promo/hero-section/money-bag.png"
     alt="Money bag" />
</template>

<script>
export default {};
</script>
